import { ChatIcon } from "./ChatIcon";
import { ChatInterface } from "./ChatInterface";
import { useSupportWidget } from "./useSupportWidget";

interface ChatWidgetProps {
  accountType?: "user" | "vendor";
  className?: string;
  iconClassName?: string;
}

export const ChatWidget = ({
  accountType,
  className,
  iconClassName,
}: ChatWidgetProps) => {
  const { isOpen, closeChat, toggleChat } = useSupportWidget(accountType);
  const controlsId =
    accountType === "vendor" ? "vendor-support-chat" : "customer-support-chat";

  return (
    <>
      <ChatInterface
        isOpen={isOpen}
        onClose={closeChat}
        accountType={accountType}
        className={className}
      />
      <ChatIcon
        onClick={toggleChat}
        isOpen={isOpen}
        controlsId={controlsId}
        className={iconClassName}
      />
    </>
  );
};
